import { render, staticRenderFns } from "./CPaletteColor.vue?vue&type=template&id=5e1e15aa&scoped=true"
import script from "./CPaletteColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./CPaletteColor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CPaletteColor.vue?vue&type=style&index=0&id=5e1e15aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1e15aa",
  null
  
)

export default component.exports